// @flow

export const setStepInputsRequire = (require: boolean, step: number) => {
  const stepNode = document.querySelector(`[data-step='${step}']`)

  stepNode?.querySelectorAll('input').forEach((input) => {
    input.required = require
  })
}
